// extracted by mini-css-extract-plugin
export default {"dialog":"WebshopRequestController_dialog__4i3cY"};